// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__A-fR_","dragIcon":"Choice_dragIcon__1lemT","left":"Choice_left__2w8T9","input":"Choice_input__3WDuD"};